/**
 * 商品説明分割スクリプト
 * product.descriptionの内容を解析し、文章(prose)と規格(specs)に分割して表示
 */
(function() {
  'use strict';

  const specsContainer = document.querySelector('[data-description-specs]');
  const proseContainer = document.querySelector('[data-description-prose]');

  if (!specsContainer || !proseContainer) return;

  // 規格コンテンツと判定するタグ
  const specsTags = ['h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'dl', 'table'];

  // 子要素を分類
  const children = Array.from(specsContainer.children);
  const proseElements = [];
  let foundSpecsContent = false;

  children.forEach((el) => {
    const tagName = el.tagName.toLowerCase();

    // 見出し・リスト・テーブルなどは規格コンテンツ
    if (specsTags.includes(tagName)) {
      foundSpecsContent = true;
      return; // specsContainerに残す
    }

    // 子要素に規格構造を含む場合も規格コンテンツ
    const hasStructure = el.querySelector('h2, h3, h4, h5, h6, ul, ol, dl, table');
    if (hasStructure) {
      foundSpecsContent = true;
      return; // specsContainerに残す
    }

    // pタグの場合
    if (tagName === 'p') {
      // 既に規格コンテンツが見つかっている場合、pタグも規格説明として扱う
      if (foundSpecsContent) {
        return; // specsContainerに残す
      }
      // まだ規格コンテンツがなければproseとして扱う
      proseElements.push(el);
      return;
    }

    // div等の場合は内容を確認
    if (tagName === 'div') {
      if (hasStructure) {
        foundSpecsContent = true;
        return;
      }
      // 規格コンテンツがまだなければproseとして扱う
      if (!foundSpecsContent) {
        proseElements.push(el);
        return;
      }
    }

    // その他のタグはそのまま残す
  });

  // proseがあれば移動
  if (proseElements.length > 0) {
    proseElements.forEach((el) => {
      proseContainer.appendChild(el);
    });
    proseContainer.style.display = '';
    proseContainer.classList.add('rte');
  }

  // specsContainerが空になった場合は非表示
  if (specsContainer.children.length === 0) {
    specsContainer.style.display = 'none';
  }
})();
